function toggleDays() {
  $('#chart_div').on('click', '#analysis_toggle_days', function (e) {
    e.preventDefault();
    $('tr.day_row_header, tr.day_row').each(function (i, r) {
      $(r).toggle();
    });
  });
} // Custom Chart Table


function loadChart() {
  var selector = ['a[id^="load_highcharts_for_analysis"], ', 'a[id^="loading_deltas_for_analysis"], ', 'a[id^="load_values_for_analysis"]'];
  $(selector.join('')).on('click', function (e) {
    e.preventDefault();
    var $this = $(this);
    var requestURL = $this.attr('href');
    var entity = $this.attr('id').split('_').slice(-2)[1];
    var date_from = $('#analysis_date_from').val();
    var date_to = $('#analysis_date_to').val();
    var entity_id = $('#analysis_' + entity + '_id').val();
    var tableContainer = $('.custom-chart-table');
    var chartContainer = $('.custom-chart-table-container');

    if ($this.is(selector[2])) {
      $('.analysis-custom-chart-container').fadeOut();
    }

    $.ajax({
      url: requestURL,
      type: 'GET',
      dataType: 'html',
      data: {
        entity: entity,
        id: entity_id,
        date_from: date_from,
        date_to: date_to
      },
      beforeSend: function beforeSend() {
        tableContainer.find('.dashboard-chart-loader').addClass('in');
        tableContainer.addClass('in');
        $('.custom-chart-table-alert').slideUp();
        $('.toggle-trigger').addClass('disabled');
      },
      success: function success(data) {
        if (data.match(/error/)) {
          $('.custom-chart-table-alert').slideDown();
          tableContainer.find('.dashboard-chart-loader').removeClass('in');
          return;
        }

        chartContainer.html(data);
      },
      error: function error(jqXHR, textStatus, errorThrown) {
        tableContainer.html('Error: ' + errorThrown);
      }
    });
  });
  toggleDays();
}

function loadAnalysisData() {
  $('a[id^="load_graph_"]').on('click', function (e) {
    e.preventDefault();
    var $this = $(this);
    var entity = $this.attr('id').split('_').slice(-2)[1];
    var date_from = $('#analysis_date_from').val();
    var date_to = $('#analysis_date_to').val();
    var entity_id = $('#analysis_' + entity + '_id').val();
    var progressIndicator = $('.loading');
    var tableContainer = $('#chart_div');
    $.ajax({
      type: 'POST',
      url: '/analysis/traffic_analysis',
      dataType: 'html',
      data: {
        entity: entity,
        id: entity_id,
        date_from: date_from,
        date_to: date_to
      },
      beforeSend: function beforeSend() {
        tableContainer.html('');
        progressIndicator.show();
      },
      success: function success(data) {
        tableContainer.html(data);
        progressIndicator.hide();
      },
      error: function error(jqXHR, textStatus, errorThrown) {
        tableContainer.html('Error: ' + errorThrown);
        progressIndicator.hide();
      }
    });
  });
}

function listenForAnalysisStatsReset() {
  $('#stats_reset').on('click', function () {
    $('select.acquirer').trigger('change');
  });
}

export { listenForAnalysisStatsReset, loadAnalysisData, loadChart };